import { useRoutes } from '@/shared/routes';

export const extractRoutes = [
  {
    path: useRoutes.EXTRACT_LIST_PATH,
    name: useRoutes.EXTRACT_LIST_NAME,
    component: () => import('@/pages/Statements'),
  },
  {
    path: `${useRoutes.EXTRACT_LIST_PATH}/i/:id`,
    name: useRoutes.EXTRACT_ITEM_TYPE_RULE,
    component: () => import('@/pages/ExtractTypeRulePage'),
  },
  {
    path: `${useRoutes.EXTRACT_LIST_PATH}/iu/:uuid`,
    name: useRoutes.EXTRACT_ITEM_TYPE_RULE_UUID,
    component: () => import('@/pages/ExtractTypeRulePage'),
  },
  {
    path: `${useRoutes.EXTRACT_LIST_PATH}/u/:uuid/:scope`,
    name: useRoutes.EXTRACT_ITEM_UUID_NAME,
    component: () => import('@/pages/ExtractsReportPage'),
  },
  {
    path: useRoutes.EXTRACT_ITEM_PATH,
    name: useRoutes.EXTRACT_ITEM_NAME,
    component: () => import('@/pages/ExtractsReportPage'),
  },
  {
    path: useRoutes.EXTRACT_CREATE_PATH,
    name: useRoutes.EXTRACT_CREATE_NAME,
    component: () => import('@/pages/ExtractCreate'),
  },
  {
    path: useRoutes.EXTRACT_PATH,
    name: useRoutes.EXTRACT_NAME,
    component: () => import('@/pages/Extract'),
  },
];
